export default function MinusIcon() {
  return (
    <g id='minus'>
      <g id='vuesax/linear/minus'>
        <g id='minus_2'>
          <path id='Vector' d='M4 8H12' />
        </g>
      </g>
    </g>
  );
}
